import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { useApp } from "../state/AppContext";
import { ArrowLeft } from "lucide-react";

// Live production domain
const APP_BASE_URL = "https://scl-kindness.emergent.host";

const QR_UTM = "utm_source=expo&utm_medium=qr&utm_campaign=scl_enrollment";

export default function QRScreen() {
  const { t, setScreen } = useApp();
  const kindnessUrl = `${APP_BASE_URL}/?path=kindness&${QR_UTM}&utm_content=kindness_qr`;
  const spinnerUrl  = `${APP_BASE_URL}/?path=activity&${QR_UTM}&utm_content=activity_qr`;

  return (
    <div className="min-h-screen bg-scl-cream pt-6 pb-32 px-6" data-testid="qr-screen">
      <button onClick={() => setScreen("home")} className="flex items-center gap-1 text-sm text-scl-charcoal/70 mb-3 hover:text-scl-teal min-h-[44px]" data-testid="qr-back">
        <ArrowLeft className="w-4 h-4" /> {t("back")}
      </button>

      <div className="mb-6">
        <div className="text-xs uppercase tracking-[0.18em] text-scl-teal font-semibold mb-2">SCL</div>
        <h1 className="font-serif text-3xl sm:text-4xl text-scl-charcoal font-bold leading-tight">{t("qr_title")}</h1>
        <p className="text-scl-charcoal/70 mt-1 text-[15px]">{t("qr_lead")}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <QRCard label={t("qr_label_kindness")} url={kindnessUrl} accent="#F08C5D" testid="qr-kindness" />
        <QRCard label={t("qr_label_spinner")} url={spinnerUrl} accent="#2E5E5C" testid="qr-spinner" />
      </div>
    </div>
  );
}

function QRCard({ label, url, accent, testid }) {
  return (
    <div className="bg-white rounded-2xl p-5 shadow-warm-sm flex flex-col items-center text-center" data-testid={testid}>
      <div className="text-xs uppercase tracking-widest font-semibold mb-3" style={{ color: accent }}>{label}</div>
      <div className="p-3 rounded-xl border border-scl-border bg-white">
        <QRCodeSVG value={url} size={220} bgColor="#FFFFFF" fgColor="#2B2A28" level="M" includeMargin={false} />
      </div>
      <div className="mt-3 text-[11px] text-scl-charcoal/60 break-all font-mono">{url}</div>
    </div>
  );
}
